import { render } from "./contexttable.vue?vue&type=template&id=828a855a"
import script from "./contexttable.vue?vue&type=script&lang=js"
export * from "./contexttable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__